<template>
<div class="card">
        <div class="card-body">

<!-- Payment success -->
          <div v-if="payment_success">

            <div class="col">
        <div class="row pb-3">
          <div class="col text-center">
            <h5>Thank you!</h5>
            <p class="mb-2 px-4">Your payment was successful</p>
            <p class="mb-0">Please check your email for confirmation</p>
        </div>
        </div>

            <div class="pt-1 pb-3 text-center">
                <a :href="'/projects/view/'+project.id+'/0'" class="btn btn-success">View project</a>
            </div>
        

      </div>

          </div>


<!-- Make payment -->
          <div v-else class="row d-flex justify-content-center">


            <div class="col-md-6 pt-2">

            <div v-if="payment_response" class="alert alert-danger text-center">{{payment_response}}</div>

            <!-- Part payment balance and card -->
            <div v-if="user.balance > 0 && user.balance < project.quote">
            <div class="alert alert-secondary text-center">{{ formattedPrice(user.balance) }} will be paid from your balance
            <br>You can pay the remaining {{ formattedPrice(project.quote - user.balance) }} with your card</div>
            </div>

            <!-- Payment from balance -->
            <div class="text-center" v-if="user.balance >= project.quote">
            <a v-if="loading" href="#/" class="btn btn-success mt-3 mb-3"><i class="fas fa-spinner fa-spin"></i></a>
            <a v-else href="#/" @click="payWithBalance" class="btn btn-success mt-3 mb-3">Pay {{ formattedPrice(project.quote) }} from balance</a>
            </div>

            <!-- Card payment -->
            <div v-else-if="cards == 0">
            <div class="text-center">
                <div v-if="publishableKey">
    <div class="text-center logos">
      <img src="/images/visa_mastercard.svg" width="90">
    </div>
    <stripe-element-card
      ref="elementRef"
      :classes="{ base: 'form-control', focus: 'form-control', invalid: 'stripe_invalid', complete: 'form-control', empty: 'stripe_empty' }"
      :pk="publishableKey"
      :hidePostalCode="true"
      @token="tokenCreated"/>

    <a v-if="loading" href="#/" class="btn btn-success mt-3 mb-3"><i class="fas fa-spinner fa-spin"></i></a>
    <a v-else href="#/" @click="submit" class="btn btn-success mt-3 mb-3">Pay {{ formattedPrice(project.quote - user.balance) }}</a>
    </div>
            </div>
            </div>

            <!-- Pay with saved card -->
            <div v-else class="text-center">
              <div class="alert alert-secondary text-center">You have a <a href="/billing" class="underline" title="Manage cards">saved card</a></div>
              <a v-if="loading" href="#/" class="btn btn-success mt-2 mb-3"><i class="fas fa-spinner fa-spin"></i></a>
              <a v-else @click="makePaymentNoToken" class="btn btn-success mt-2 mb-3">Pay {{ formattedPrice(project.quote - user.balance) }}</a>
            </div>

            </div>
          </div>




        </div>
        </div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';

export default {
  props: ['project', 'user', 'cards'],

  components: {
    StripeElementCard,
  },

  data () {
    return {
      token: null,
      publishableKey: null,
      payment_response: null,
      payment_success: false,
      loading: false,
    };
  },

  created() {
    this.getStripeKey();
  },

  methods: {

    getStripeKey() {
      axios.get('/subscriptions/stripe-key').
      then((response) => {
        this.publishableKey = response.data;
      });
    },

    submit () {
      this.$refs.elementRef.submit();
    },

    tokenCreated (token) {
      this.token = token;
      this.makePayment();
    },

    makePayment() {
      
      this.payment_response = null;
      this.loading = true;

      axios.post('/projects/payment', {
        stripeToken: this.token.id,
        project_id: this.project.id,
      })
      .then((response) => {
        if (response.data.success) {
          this.payment_success = true;
        } else {
          this.payment_response = response.data.message;
        }
        this.loading = false;
      });
    },

    makePaymentNoToken() {
      
      this.payment_response = null;
      this.loading = true;

      axios.post('/projects/payment', {
        stripeToken: null,
        project_id: this.project.id,
      })
      .then((response) => {
        if (response.data.success) {
          this.payment_success = true;
        } else {
          this.payment_response = response.data.message;
        }
        this.loading = false;
      });
    },

    payWithBalance() {
      
      this.payment_response = null;
      this.loading = true;

      axios.post('/projects/payment-balance', {
        project_id: this.project.id,
      })
      .then((response) => {
        if (response.data.success) {
          this.payment_success = true;
        } else {
          this.payment_response = response.data.message;
        }
        this.loading = false;
      });
    },

  }
};
</script>

<style scoped>
.logos {
  background-color: #fff;
  padding: 0.4rem 2rem;
  border-radius: 5px;
  width:fit-content;
  margin: 0 auto 1rem auto;
}
.underline {
  text-decoration: underline;
}
.form-control {
  border-radius:50px !important;
}
.form-control:focus {
  box-shadow: none !important;
  outline: none !important;
}
.StripeElement--focus {
  box-shadow: none !important;
  outline: none !important;
}
</style>